import React from 'react';
import {SurveyPagePropTypes} from '@ignitesales/neuro-application/src/neuro-guide';
import {PageContainer, GuideAppContainer, RenderOnlyFor, PageNavigation} from '@ignitesales/neuro-application';
import Footer from '../Footer';

const SurveyPage = ({ className, componentClass, renderQuestionGroups }) => {
  let img = "image-3-arrows-man-b.svg";
  let imgPath = "/classpath/assets/images/svg/" + img;

  return (
    <div>
      <div className={className}>
        <div className="sidebar">
          <div className="background">
          </div>
        </div>
        <div className="component component--twoThird questionGroupComponent">
          { renderQuestionGroups() } 
        </div>
        <Footer/>
      </div>
      <div className="page-nav-container"><PageNavigation toastTimeout={ 3000 } /></div>
    </div>
  );
};

SurveyPage.propTypes = SurveyPagePropTypes;

export default SurveyPage;